import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shell-external',
  templateUrl: './shell-external.component.html',
  styleUrls: ['./shell-external.component.scss']
})
export class ShellExternalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
